<p-dialog
  header="Select FPCs"
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '560px' }"
  (onHide)="close()"
>
  <div class="fpc-selector">
    <div class="fpc-search">
      <i class="pi pi-search search-icon"></i>
      <input
        type="text"
        pInputText
        placeholder="Search by variant code or description"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
        class="search-input"
      />
    </div>

    <div class="fpc-list">
      @for (item of pagedItems; track item.fpcCode) {
        <label class="fpc-row" [class.fpc-row--checked]="isPending(item.fpcCode)">
          <input
            type="checkbox"
            class="fpc-checkbox"
            [checked]="isPending(item.fpcCode)"
            (change)="toggleItem(item)"
          />
          <span class="fpc-code">{{ item.codeDisplay }}</span>
          <span class="fpc-name">{{ item.name }}</span>
        </label>
      } @empty {
        <div class="fpc-empty">No results</div>
      }
    </div>

    <div class="fpc-pagination">
      <button pButton type="button" icon="pi pi-angle-left" class="p-button-text p-button-sm"
              [disabled]="currentPage === 0" (click)="currentPage = currentPage - 1"></button>
      <span class="page-info">{{ currentPage + 1 }} / {{ totalPages }}</span>
      <button pButton type="button" icon="pi pi-angle-right" class="p-button-text p-button-sm"
              [disabled]="currentPage >= totalPages - 1" (click)="currentPage = currentPage + 1"></button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <span class="fpc-count">{{ pendingCodes().size }} selected</span>
    <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="close()"></button>
    <button pButton type="button" label="Confirm" (click)="confirm()"></button>
  </ng-template>
</p-dialog>
